import { render, staticRenderFns } from "./EmrDocumentScan.vue?vue&type=template&id=f1ded2f8&"
import script from "./EmrDocumentScan.vue?vue&type=script&lang=js&"
export * from "./EmrDocumentScan.vue?vue&type=script&lang=js&"
import style0 from "./EmrDocumentScan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports